/* KUVA collection filters.

   The section's baseline is a plain GET form - filtering works with JS disabled.
   This file exists because the baseline behaviour compounded badly in practice:

   - <details> panels have no coordination, so opening Price left Colour open and
     the panels stacked on top of each other and the sort menu.
   - Every checkbox ran form.submit(): a FULL page navigation per tick. Click three
     boxes and three navigations queue while the page sits frozen - the "site hangs"
     report. And after each reload every panel is closed again, so refining a filter
     meant reopening it each time.

   Fixes, in order: one panel open at a time; outside click and Escape close them;
   and filtering re-renders the section in place through Shopify's Section Rendering
   API - no reload, the panel stays open, the grid dims while loading. Any fetch
   failure falls back to plain navigation, which is the no-JS path anyway.

   Bound once at document level so it keeps working after the section's DOM is
   swapped by a render. */
(function () {
  if (window.__kuvaColBound) return;
  window.__kuvaColBound = true;

  function wrap (el) { return el.closest('[id^="kuva-col-"]'); }
  function panels (root) { return (root || document).querySelectorAll('details.kx-f[open]'); }

  /* toggle does not bubble; capture sees it anyway. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('kx-f') || !d.open) return;
    var w = wrap(d);
    if (!w) return;
    panels(w).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  document.addEventListener('click', function (e) {
    panels().forEach(function (o) { if (!o.contains(e.target)) o.open = false; });

    /* Active-filter chips and "clear" are plain links; take them down the same
       in-place path as the form so removing a filter does not reload either. */
    var chip = e.target.closest('.kx-active a');
    if (chip && window.fetch) {
      var w = wrap(chip);
      if (w) { e.preventDefault(); load(w, chip.href); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') panels().forEach(function (o) { o.open = false; });
  });

  /* The controls call requestSubmit(), which fires a real submit event (submit()
     does not) - so this intercept works, and without this file the same call just
     performs the native GET. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[id^="kuva-filters-"]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    load(wrap(form), form.getAttribute('action').split('?')[0] + '?' + params.toString());
  });

  var seq = 0;
  function load (w, url) {
    var my = ++seq;
    var grid = w.querySelector('.kx-grid');
    if (grid) grid.setAttribute('aria-busy', 'true');

    /* Remember which panel is open so the swap does not slam it shut mid-refine. */
    var openIdx = -1;
    w.querySelectorAll('details.kx-f').forEach(function (d, i) { if (d.open) openIdx = i; });

    var sectionId = w.id.replace('kuva-col-', '');
    var join = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + join + 'section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        if (my !== seq) return;  /* a newer request superseded this one */
        var next = new DOMParser().parseFromString(html, 'text/html').getElementById(w.id);
        if (!next) throw 0;
        w.innerHTML = next.innerHTML;
        history.pushState({ kuvaCol: true }, '', url);
        if (openIdx > -1) {
          var d = w.querySelectorAll('details.kx-f')[openIdx];
          if (d) d.open = true;
        }
      })
      .catch(function () { window.location.href = url; });
  }

  /* pushState means back/forward must restore earlier results; a reload is the
     honest way to do that without shadow state. */
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.kuvaCol) location.reload();
  });
})();
